import script from "./Cards.vue?vue&type=script&setup=true&lang=js"
export * from "./Cards.vue?vue&type=script&setup=true&lang=js"

import "./Cards.vue?vue&type=style&index=0&id=7f01b76c&lang=scss&scoped=true"

import exportComponent from "/builds/aquaverse/thales/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f01b76c"]])

export default __exports__